import React from 'react';
import { DPage, DPageBody } from '../../../../dum';
import { OrderAdjustmentsListBlock } from './blocks/order-adjustments-block';

export function OrderAdjustmentsPage() {
    return (
        <DPage animated>
            <DPageBody disableGutters>
                <OrderAdjustmentsListBlock />
            </DPageBody>
        </DPage>
    );
}
